import { injectIntl } from "react-intl";

import MelodyTable from "./loadable";

export default injectIntl(MelodyTable);